/**
 * Filter for facets in mobile and desktop
 */
export default {
  props: {
    facets: {
      type: Array,
    },
  },
  computed: {
    /**
     * filteredFacets - to sort selected facets based on item count
     */
    filteredFacets() {
      const sorted = this.facets.map(c => {
        const values = c.values.map(v => {
          return {
            ...v,
          };
        });

        // Sort by selected first, then sort by count
        values.sort((f1, f2) => {
          if (f1.selected && !f2.selected) {
            return -1;
          }

          if (f2.selected && !f1.selected) {
            return 1;
          }

          return f2.count - f1.count;
        });

        return {
          ...c,
          values,
        };
      });
      return sorted;
    },
    /**
     * Computed property to hold the selected category values from the Categories
     * @returns {Array} filteredSelectedValues - filtered selected category values
     */
    filteredSelectedValues() {
      const newFilteredList = [];
      if (this.filteredFacets) {
        // Iterate through the list of categories to retrieve the selected values in the newFilteredList array
        this.filteredFacets.forEach(category => {
          if (category && category.values) {
            // Filter selected values from a category
            const filteredValue = category.values.filter(value => value && value.selected);
            if (filteredValue && filteredValue.length) {
              const newCategory = {
                ...category,
                values: filteredValue,
              };
              // Add the category if it has any selected value
              newFilteredList.push(newCategory);
            }
          }
        });
      }
      this.$emit('categoryValuesSelected', newFilteredList);
      return newFilteredList;
    },
  },
  methods: {
    /**
     * isAllClear - check if there is any facet selected
     */
    isAllClear() {
      return !this.facets.some(category => category.values.some(value => value.selected));
    },
    /**
     * Method to change the status of filteredFacets
     * @param {Object} category - category of facet
     * @param {Object} value - the selected value
     * @param {Boolean} $event - whether facet is selected or not
     */
    onChange(category, value, $event) {
      const copy = this.facets.map(c => {
        if (category.key !== c.key) {
          return c;
        }

        const values = c.values.map(v => {
          if (v.key !== value.key) {
            return v;
          }

          return {
            ...v,
            selected: $event,
          };
        });

        return {
          ...c,
          values,
        };
      });
      this.$emit('change', copy);
    },
    /**
     * Method to clear the filters for the provided category
     * @param {Object} category - category filter to be cleared
     */
    clearCategoryFilters(category) {
      const copy = this.facets.map(c => {
        if (c.key !== category.key) {
          return c;
        }

        const values = c.values.map(facet => ({ ...facet, selected: false }));
        return {
          ...c,
          values,
        };
      });

      this.$emit('change', copy);
    },
  },
};
